var render = function render(){var _vm=this,_c=_vm._self._c;return _c('keep-alive',[_c('div',{staticClass:"res"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('reservation.res2.title')))]),_c('div',{staticClass:"content"},[_c('ticket-picker')],1),(_vm.showCharityPopup)?_c('charity-popup'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }